import script from "./CarouselTest.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselTest.vue?vue&type=script&setup=true&lang=js"

import "./CarouselTest.vue?vue&type=style&index=0&id=4db19081&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db19081"]])

export default __exports__